import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import {
  IntegrationMappingModel,
  IntegrationProjectTemplateAssociationModel,
  IntegrationProjectTemplateAssociationUpsertModel,
  IntegrationTemplateAssociationModel,
  IntegrationTemplateCloneRequestModel,
  IntegrationTemplateCloneResultModel
} from '../models/integration.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  private readonly baseUrl = 'Integration';

  constructor(private apiService: ApiService) {}

  getIntegrationMappings(integrationType: string): Observable<IntegrationMappingModel[]> {
    return this.apiService.get(`${this.baseUrl}/GetIntegrationMappings/${integrationType}`);
  }

  getTemplateAssociations(templateId: number): Observable<IntegrationTemplateAssociationModel[]> {
    return this.apiService.get(`${this.baseUrl}/GetTemplateAssociations/${templateId}`);
  }

  getProjectTemplateAssociations(projectTemplateId: number, integrationType: string): Observable<IntegrationProjectTemplateAssociationModel[]> {
    return this.apiService.get(`${this.baseUrl}/GetProjectTemplateAssociations/${projectTemplateId}?integrationType=${encodeURIComponent(integrationType)}`);
  }

  upsertIntegrationMappings(payload: IntegrationMappingModel[]): Observable<{ savedCount: number; totalCount: number; items: IntegrationMappingModel[] }> {
    return this.apiService.post(`${this.baseUrl}/UpsertIntegrationMappings`, payload);
  }

  cloneTemplateAssociations(payload: IntegrationTemplateCloneRequestModel): Observable<IntegrationTemplateCloneResultModel> {
    return this.apiService.post(`${this.baseUrl}/CloneTemplateAssociations`, payload);
  }

  upsertProjectTemplateAssociations(payload: IntegrationProjectTemplateAssociationUpsertModel): Observable<{ projectTemplateId: number; selectedCount: number }> {
    return this.apiService.post(`${this.baseUrl}/UpsertProjectTemplateAssociations`, payload);
  }

  deleteIntegrationMapping(integrationId: number): Observable<any> {
    return this.apiService.delete(`${this.baseUrl}/DeleteIntegrationMapping/${integrationId}`);
  }
}
